import React from 'react'
import MainLaundryTable from 'components/Tables/MainLaundry/MainLaundryTable'

const ListLaundry = () => {
  return (
    <div><MainLaundryTable /></div>
  )
}

export default ListLaundry